import {FormFieldType} from "../enums/form-field-type.enum";

export function fieldTypeHasDefaultOption(value: string): boolean {
  const fieldType = value as FormFieldType;
  return fieldType === FormFieldType.SELECT || fieldType === FormFieldType.RADIO;
}
